import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import "../../styles/components/Layout/Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>{t("common", "footer.explore")}</h3>
          <ul className="footer-links">
            <li>
              <a href="/">{t("common", "footer.home")}</a>
            </li>
            <li>
              <a href="#features">{t("common", "footer.features")}</a>
            </li>
            <li>
              <a href="#gallery">{t("common", "footer.gallery")}</a>
            </li>
            <li>
              <a href="#characters">{t("common", "footer.characters")}</a>
            </li>
            <li>
              <a href="#story">{t("common", "footer.history")}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t("common", "footer.resources")}</h3>
          <ul className="footer-links">
            <li>
              <a href="/download">{t("common", "footer.downloads")}</a>
            </li>
            <li>
              <a href="#patches">{t("common", "footer.patches")}</a>
            </li>
            <li>
              <a href="#guides">{t("common", "footer.guides")}</a>
            </li>
            <li>
              <a href="#faq">{t("common", "footer.FAQ")}</a>
            </li>
            <li>
              <a href="#support">{t("common", "footer.support")}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t("common", "footer.community")}</h3>
          <ul className="footer-links">
            <li>
              <a href="#forums">{t("common", "footer.forums")}</a>
            </li>
            <li>
              <a href="#events">{t("common", "footer.events")}</a>
            </li>
            <li>
              <a href="#clans">{t("common", "footer.clans")}</a>
            </li>
            <li>
              <a href="#contests">{t("common", "footer.contests")}</a>
            </li>
            <li>
              <a href="#wiki">{t("common", "footer.wiki")}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t("common", "footer.connect")}</h3>
          <p>{t("common", "footer.followUs")}</p>
          <div className="social-links">
            <a href="#">
              <i className="fab fa-discord"></i>
            </a>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.youtube.com/@jairodavidbelencoronado2502"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://instagram.com/orial021"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#">
              <i className="fab fa-reddit"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="copyright">
        © {currentYear} {t("common", "footer.copyRight")}{" "}
        <i className="fas fa-heart" style={{ color: "var(--secondary)" }}></i>{" "}
        {t("common", "footer.company")}
      </div>
    </footer>
  );
};

export default Footer;
